import React, { useMemo, useState } from "react";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import styles from "./styles.module.scss";
import CheckBox from "app/components/inputs/CheckBox/Base";
import { Loading } from "app/components/Wrappers";
import useInterval from "app/utils/hooks/useIntervall";
import { useTranslation } from "react-i18next";
import {
  schedulingFetchGet,
  schedulingFetchPost,
} from "app/utils/request/scheduling/fetch";
import { downloadExport } from "../../ReportContent/ReportBody/helper";

interface IFileFormatModalProps {
  report: any;
  filters: object;
  isOpen: boolean;
  setShowDownloadModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const FileFormatModal = ({
  report,
  filters,
  isOpen,
  setShowDownloadModal,
}: IFileFormatModalProps) => {
  const [XLSXFormat, setXLSXFormat] = useState(true);
  const [showButtons, setShowButtons] = useState(true);
  const [generatedReport, setGeneratedReport] = useState(null);
  const { t } = useTranslation();

  const isPolling = useMemo(() => {
    return generatedReport?.status === "pending";
  }, [generatedReport?.status]);

  useInterval(
    () => {
      if (!generatedReport) {
        return;
      }

      schedulingFetchGet(`generated_reports/${generatedReport.id}`)
        .then((response) => {
          setGeneratedReport(response);

          if (response.status === "completed") {
            setShowDownloadModal(false);
            setShowButtons(true);
            downloadExport(response.reportFileUrl, response.filename);
          }
        })
        .catch((error) => {
          setGeneratedReport((prev) => {
            return {
              ...prev,
              status: "failed",
            };
          });
          console.log(error);
          setShowButtons(true);
        });
    },
    isPolling ? 1000 : null,
  );

  const generateExport = () => {
    setShowButtons(false);

    schedulingFetchPost<any[]>(`reports/${report.id}/generated_reports`, {
      ...filters,
      format: XLSXFormat ? "xlsx" : "csv",
    })
      .then((response) => {
        setGeneratedReport(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <ModalLayout
      isOpen={isOpen}
      classNames={styles.modal_container}
      centerVertically={true}
    >
      <div className={styles.modal_content}>
        <div className={styles.title}>
          <h2>{t("File Format")}</h2>
          <div
            className={styles.close_button}
            onClick={() => setShowDownloadModal(false)}
          >
            <i className="ico ico-x" />
          </div>
        </div>
        {isPolling ? (
          <div>
            <Loading isLoading loadType="spinner" />
          </div>
        ) : (
          <div className={styles.content}>
            <div
              className={styles.checkbox}
              onClick={() => setXLSXFormat(true)}
            >
              <CheckBox disabled={true} checked={XLSXFormat} />
              <span>{t("XLSX")}</span>
            </div>
            <div
              className={styles.checkbox}
              onClick={() => setXLSXFormat(false)}
            >
              <CheckBox disabled={true} checked={!XLSXFormat} />
              <span>{t("CSV")}</span>
            </div>
          </div>
        )}
        {showButtons ? (
          <div className={styles.buttons_container}>
            <button
              className={styles.cancel_button}
              onClick={() => setShowDownloadModal(false)}
            >
              {t("Cancel")}
            </button>
            <button className={styles.generate_button} onClick={generateExport}>
              {t("Generate")}
            </button>
          </div>
        ) : null}
      </div>
    </ModalLayout>
  );
};

export default FileFormatModal;
